import { toSimplifiedChinese } from './simplifiedChinese.js';

export const COUNTRY_NAMES = Object.freeze({
  en: Object.freeze({
    us: 'United States',
    gb: 'United Kingdom',
    ca: 'Canada',
    au: 'Australia',
    nz: 'New Zealand',
    ie: 'Ireland',
    de: 'Germany',
    fr: 'France',
    it: 'Italy',
    es: 'Spain',
    pt: 'Portugal',
    nl: 'Netherlands',
    be: 'Belgium',
    at: 'Austria',
    ch: 'Switzerland',
    se: 'Sweden',
    no: 'Norway',
    dk: 'Denmark',
    fi: 'Finland',
    gr: 'Greece',
    pl: 'Poland',
    cz: 'Czech Republic',
    hu: 'Hungary',
    ro: 'Romania',
    ru: 'Russia',
    tr: 'Turkey',
    ua: 'Ukraine',
    jp: 'Japan',
    kr: 'South Korea',
    cn: 'China mainland',
    hk: 'Hong Kong',
    tw: 'Taiwan',
    sg: 'Singapore',
    id: 'Indonesia',
    th: 'Thailand',
    my: 'Malaysia',
    ph: 'Philippines',
    vn: 'Vietnam',
    kh: 'Cambodia',
    in: 'India',
    pk: 'Pakistan',
    lk: 'Sri Lanka',
    bd: 'Bangladesh',
    sa: 'Saudi Arabia',
    ae: 'UAE',
    il: 'Israel',
    eg: 'Egypt',
    kw: 'Kuwait',
    qa: 'Qatar',
    bh: 'Bahrain',
    om: 'Oman',
    jo: 'Jordan',
    ma: 'Morocco',
    lb: 'Lebanon',
    tn: 'Tunisia',
    dz: 'Algeria',
    za: 'South Africa',
    ng: 'Nigeria',
    ke: 'Kenya',
    gh: 'Ghana',
    tz: 'Tanzania',
    ug: 'Uganda',
    zm: 'Zambia',
    ci: "Cote d'Ivoire",
    sn: 'Senegal',
    br: 'Brazil',
    mx: 'Mexico',
    ar: 'Argentina',
    co: 'Colombia',
    cl: 'Chile',
    pe: 'Peru',
    ve: 'Venezuela',
    cr: 'Costa Rica',
    do: 'Dominican Republic',
    ec: 'Ecuador',
    gt: 'Guatemala',
    pa: 'Panama',
    uy: 'Uruguay',
    bo: 'Bolivia',
    py: 'Paraguay',
  }),
  ja: Object.freeze({
    us: 'アメリカ',
    gb: 'イギリス',
    ca: 'カナダ',
    au: 'オーストラリア',
    nz: 'ニュージーランド',
    ie: 'アイルランド',
    de: 'ドイツ',
    fr: 'フランス',
    it: 'イタリア',
    es: 'スペイン',
    pt: 'ポルトガル',
    nl: 'オランダ',
    be: 'ベルギー',
    at: 'オーストリア',
    ch: 'スイス',
    se: 'スウェーデン',
    no: 'ノルウェー',
    dk: 'デンマーク',
    fi: 'フィンランド',
    gr: 'ギリシャ',
    pl: 'ポーランド',
    cz: 'チェコ',
    hu: 'ハンガリー',
    ro: 'ルーマニア',
    ru: 'ロシア',
    tr: 'トルコ',
    ua: 'ウクライナ',
    jp: '日本',
    kr: '韓国',
    cn: '中国本土',
    hk: '香港',
    tw: '台湾',
    sg: 'シンガポール',
    id: 'インドネシア',
    th: 'タイ',
    my: 'マレーシア',
    ph: 'フィリピン',
    vn: 'ベトナム',
    kh: 'カンボジア',
    in: 'インド',
    pk: 'パキスタン',
    lk: 'スリランカ',
    bd: 'バングラデシュ',
    sa: 'サウジアラビア',
    ae: 'UAE',
    il: 'イスラエル',
    eg: 'エジプト',
    kw: 'クウェート',
    qa: 'カタール',
    bh: 'バーレーン',
    om: 'オマーン',
    jo: 'ヨルダン',
    ma: 'モロッコ',
    lb: 'レバノン',
    tn: 'チュニジア',
    dz: 'アルジェリア',
    za: '南アフリカ',
    ng: 'ナイジェリア',
    ke: 'ケニア',
    gh: 'ガーナ',
    tz: 'タンザニア',
    ug: 'ウガンダ',
    zm: 'ザンビア',
    ci: 'コートジボワール',
    sn: 'セネガル',
    br: 'ブラジル',
    mx: 'メキシコ',
    ar: 'アルゼンチン',
    co: 'コロンビア',
    cl: 'チリ',
    pe: 'ペルー',
    ve: 'ベネズエラ',
    cr: 'コスタリカ',
    do: 'ドミニカ共和国',
    ec: 'エクアドル',
    gt: 'グアテマラ',
    pa: 'パナマ',
    uy: 'ウルグアイ',
    bo: 'ボリビア',
    py: 'パラグアイ',
  }),
  'zh-CN': Object.freeze({
    us: '美国',
    gb: '英国',
    ca: '加拿大',
    au: '澳大利亚',
    nz: '新西兰',
    ie: '爱尔兰',
    de: '德国',
    fr: '法国',
    it: '意大利',
    es: '西班牙',
    pt: '葡萄牙',
    nl: '荷兰',
    be: '比利时',
    at: '奥地利',
    ch: '瑞士',
    se: '瑞典',
    no: '挪威',
    dk: '丹麦',
    fi: '芬兰',
    gr: '希腊',
    pl: '波兰',
    cz: '捷克',
    hu: '匈牙利',
    ro: '罗马尼亚',
    ru: '俄罗斯',
    tr: '土耳其',
    ua: '乌克兰',
    jp: '日本',
    kr: '韩国',
    cn: '中国大陆',
    hk: '香港',
    tw: '台湾',
    sg: '新加坡',
    id: '印度尼西亚',
    th: '泰国',
    my: '马来西亚',
    ph: '菲律宾',
    vn: '越南',
    kh: '柬埔寨',
    in: '印度',
    pk: '巴基斯坦',
    lk: '斯里兰卡',
    bd: '孟加拉国',
    sa: '沙特阿拉伯',
    ae: '阿联酋',
    il: '以色列',
    eg: '埃及',
    kw: '科威特',
    qa: '卡塔尔',
    bh: '巴林',
    om: '阿曼',
    jo: '约旦',
    ma: '摩洛哥',
    lb: '黎巴嫩',
    tn: '突尼斯',
    dz: '阿尔及利亚',
    za: '南非',
    ng: '尼日利亚',
    ke: '肯尼亚',
    gh: '加纳',
    tz: '坦桑尼亚',
    ug: '乌干达',
    zm: '赞比亚',
    ci: '科特迪瓦',
    sn: '塞内加尔',
    br: '巴西',
    mx: '墨西哥',
    ar: '阿根廷',
    co: '哥伦比亚',
    cl: '智利',
    pe: '秘鲁',
    ve: '委内瑞拉',
    cr: '哥斯达黎加',
    do: '多米尼加共和国',
    ec: '厄瓜多尔',
    gt: '危地马拉',
    pa: '巴拿马',
    uy: '乌拉圭',
    bo: '玻利维亚',
    py: '巴拉圭',
  }),
  'zh-Hant': Object.freeze({
    us: '美國',
    gb: '英國',
    ca: '加拿大',
    au: '澳洲',
    nz: '紐西蘭',
    ie: '愛爾蘭',
    de: '德國',
    fr: '法國',
    it: '義大利',
    es: '西班牙',
    pt: '葡萄牙',
    nl: '荷蘭',
    be: '比利時',
    at: '奧地利',
    ch: '瑞士',
    se: '瑞典',
    no: '挪威',
    dk: '丹麥',
    fi: '芬蘭',
    gr: '希臘',
    pl: '波蘭',
    cz: '捷克',
    hu: '匈牙利',
    ro: '羅馬尼亞',
    ru: '俄羅斯',
    tr: '土耳其',
    ua: '烏克蘭',
    jp: '日本',
    kr: '南韓',
    cn: '中國大陸',
    hk: '香港',
    tw: '台灣',
    sg: '新加坡',
    id: '印尼',
    th: '泰國',
    my: '馬來西亞',
    ph: '菲律賓',
    vn: '越南',
    kh: '柬埔寨',
    in: '印度',
    pk: '巴基斯坦',
    lk: '斯里蘭卡',
    bd: '孟加拉',
    sa: '沙烏地阿拉伯',
    ae: '阿聯酋',
    il: '以色列',
    eg: '埃及',
    kw: '科威特',
    qa: '卡達',
    bh: '巴林',
    om: '阿曼',
    jo: '約旦',
    ma: '摩洛哥',
    lb: '黎巴嫩',
    tn: '突尼西亞',
    dz: '阿爾及利亞',
    za: '南非',
    ng: '奈及利亞',
    ke: '肯亞',
    gh: '迦納',
    tz: '坦尚尼亞',
    ug: '烏干達',
    zm: '尚比亞',
    ci: '象牙海岸',
    sn: '塞內加爾',
    br: '巴西',
    mx: '墨西哥',
    ar: '阿根廷',
    co: '哥倫比亞',
    cl: '智利',
    pe: '秘魯',
    ve: '委內瑞拉',
    cr: '哥斯大黎加',
    do: '多明尼加共和國',
    ec: '厄瓜多',
    gt: '瓜地馬拉',
    pa: '巴拿馬',
    uy: '烏拉圭',
    bo: '玻利維亞',
    py: '巴拉圭',
  }),
});

/**
 * Resolve a storefront country code against country-name maps.
 * @param {string|null|undefined} code
 * @param {string} locale
 * @param {string} [fallback]
 * @param {Record<string, Record<string, string>>} [maps]
 * @returns {string}
 */
export function lookupCountryName(code, locale, fallback, maps = COUNTRY_NAMES) {
  const normalizedCode = String(code ?? '').trim().toLowerCase();
  if (!normalizedCode) return fallback ?? '';
  const localized = maps[locale]?.[normalizedCode];
  if (localized) return localized;
  if (locale === 'zh-CN') {
    const traditional = maps['zh-Hant']?.[normalizedCode];
    if (traditional) return toSimplifiedChinese(traditional);
  }
  const english = maps.en?.[normalizedCode];
  if (english) return english;
  return fallback ?? normalizedCode;
}
